"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValue = exports.getTextWidth = exports.getLoaderProps = exports.getInertColors = exports.getActiveColors = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styledComponents = require("styled-components");
var _grey = _interopRequireDefault(require("../../tokens/color/grey"));
var _red = _interopRequireDefault(require("../../tokens/color/red"));
var _teal = _interopRequireDefault(require("../../tokens/color/teal"));
var _white = _interopRequireDefault(require("../../tokens/color/white"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // sushi
// constants
var FOCUS_PROPS_MAPPING = ["chipBg", "chipFont", "chipBorder", "chipCross"];
var COLOR_PROPS_MAPPING = ["borderColor", "color", "labelFont"];
var moveLabelTop = /*#__PURE__*/(0, _styledComponents.css)(["font-size:1.2rem;margin:0;top:-1rem;left:1.2rem;padding:0 0.5rem;"]);
var getFocusPropValue = function getFocusPropValue(theme) {
  return function (acc, key) {
    if (theme.focused) return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, theme.activeColors[key]));
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, theme.inertColors[key]));
  };
};
var getColorPropValue = function getColorPropValue(theme) {
  return function (acc, key) {
    var k = key;
    if (key === "borderColor") k = "border";else if (key === "color") k = "font";
    if (theme.error) return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, _red["default"].z500));else if (theme.focused) return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, theme.activeColors[k]));else return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, theme.inertColors[k]));
  };
};
var getPropValue = function getPropValue(globalTheme, hasList) {
  var _globalTheme$chipInpu = globalTheme.chipInputProps,
    theme = _globalTheme$chipInpu === void 0 ? {} : _globalTheme$chipInpu;
  var shouldMoveLabel = hasList || theme.error || theme.focused || theme.input || theme.loading;
  var modifiedProps = _objectSpread(_objectSpread(_objectSpread({}, FOCUS_PROPS_MAPPING.reduce(getFocusPropValue(theme), {})), COLOR_PROPS_MAPPING.reduce(getColorPropValue(theme), {})), {}, {
    moveLabel: shouldMoveLabel ? moveLabelTop : "",
    helperTxtColor: theme.error ? _red["default"].z500 : _grey["default"].z600,
    loaderAlign: theme.loaderProps.align,
    bgColor: theme.bgColor
  });
  return _objectSpread(_objectSpread({}, theme), modifiedProps);
};
var getValue = exports.getValue = function getValue(key, listLength) {
  return function (_ref) {
    var theme = _ref.theme;
    return getPropValue(theme, !!listLength)[key];
  };
};

// getTextWidth takes a string and its font type and return the width
// of the string in pixels
var getTextWidth = exports.getTextWidth = function getTextWidth(text, font) {
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d");
  context.font = font || getComputedStyle(document.body).font;
  return context.measureText(text).width;
};
var getActiveColors = exports.getActiveColors = function getActiveColors(newValues) {
  return _objectSpread({
    border: _teal["default"].z400,
    font: _grey["default"].z800,
    labelFont: _teal["default"].z400,
    chipBg: _red["default"].z500,
    chipFont: _white["default"],
    chipCross: _white["default"],
    chipBorder: "rgba(0,0,0,0)"
  }, newValues);
};
var getInertColors = exports.getInertColors = function getInertColors(newValues) {
  return _objectSpread({
    border: _grey["default"].z300,
    font: _grey["default"].z400,
    labelFont: _grey["default"].z400,
    chipBg: _red["default"].z500,
    chipFont: _white["default"],
    chipCross: _white["default"],
    chipBorder: "rgba(0,0,0,0)"
  }, newValues);
};
var getLoaderProps = exports.getLoaderProps = function getLoaderProps(newValues) {
  return _objectSpread({
    color: _grey["default"].z200,
    size: "small",
    align: "center"
  }, newValues);
};